import { render, staticRenderFns } from "./Model20.vue?vue&type=template&id=84ff3d86&scoped=true&"
import script from "./Model20.vue?vue&type=script&lang=js&"
export * from "./Model20.vue?vue&type=script&lang=js&"
import style0 from "./Model20.vue?vue&type=style&index=0&id=84ff3d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ff3d86",
  null
  
)

export default component.exports